/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Metadata_Ogimagefallback2Inputs */

const ja_metadata_ogimagefallback2 = /** @type {(inputs: Metadata_Ogimagefallback2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`https://dev.asset.playbrain.com/content-assets/defaults/playbrain-og-default-1200x630.png`)
};

const en_metadata_ogimagefallback2 = /** @type {(inputs: Metadata_Ogimagefallback2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`https://dev.asset.playbrain.com/content-assets/defaults/playbrain-og-default-1200x630.png`)
};

/**
* | output |
* | --- |
* | "https://dev.asset.playbrain.com/content-assets/defaults/playbrain-og-default-1200x630.png" |
*
* @param {Metadata_Ogimagefallback2Inputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
const metadata_ogimagefallback2 = /** @type {((inputs?: Metadata_Ogimagefallback2Inputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Metadata_Ogimagefallback2Inputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ja") return ja_metadata_ogimagefallback2(inputs)
	return en_metadata_ogimagefallback2(inputs)
});
export { metadata_ogimagefallback2 as "metadata_ogImageFallback" }